<template>
  <div>
    <ul class="tabs">
      <li v-for="app in apps" :key="app.appCode" @click="handleAppClick(app)">
        <div class="tabs_class" style="background: rgba(227, 242, 255, 0.72)">
          <img :src="getImgUrl(app)" alt="" />
        </div>
        <div class="tabs_class1">
          <span style="font-size: 14px; color: #303133;">{{ app.appName }}</span>
          <span style="font-size: 12px; color: #606266; margin-top: 5px">{{ app.notes }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import workbench from "@/CommonDP/router/modules/workbench";
import project from "@/CommonDP/router/modules/project";
import knowledge from "@/CommonDP/router/modules/knowledge";
import message from "@/CommonDP/router/modules/message";
import application from "@/CommonDP/router/modules/application";
import system from "@/CommonDP/router/modules/system";
import userCenter from "@/CommonDP/router/modules/userCenter";
import admin from "@/CommonDP/router/modules/admin";
import { mapState } from "vuex";
import platformService from "@/CommonDP/service/platform-service";
export const dynamic = [

  ...workbench,
  ...project,
  ...knowledge,
  ...message,
  ...application,
  ...system,
  ...userCenter,
  ...admin
];
export default {
  props: {
    apps: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      imagePath: '',
      standard: require("@/CommonDP/assets/approval/standard.png")
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {

  },
  methods: {

    handleAppClick(app) {
      const params = {
        businessId: app.appCode,
        businessType: "app",
        clientType: 'web',
        enterpriseId: this.enterpriseId
      };
      platformService.savePubUserVisit(params);
      if (app.routerName) {
        this.$router.push({ name: app.routerName });
      } else if (app.targetUrl) {
        this.$router.push({ path: app.targetUrl });
      }
    },
    getImgUrl(app) {
      const image = this.getTreeName(dynamic, app.routerName);
      if (image) {
        return image;
      } else {
        return require("@/CommonDP/assets/approval/standard.png");
      }
    },
    getTreeName(list, routerName) {
      let res = list.find(item => item.name == routerName);
      if (res) {
        if (res.meta.icon) {
          return res.meta.icon;
        }
      } else {
        for (let i = 0; i < list.length; i++) {
          if (list[i].children instanceof Array && list[i].children.length > 0) {
            res = this.getTreeName(list[i].children, routerName);
            if (res) {
              return res;
            }
          }
        }
      }
    }

  }
};
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  li {
    margin: 5px 0;
    width: 215px;
    height: 100px;
    background: #ffffff;
    border-radius: 5px;
    margin-right: 20px;
    display: flex;
    cursor: pointer;
    // justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    .tabs_class {
      width: 46px;
      height: 46px;
      flex-shrink: 0;
      border-radius: 10px;
      margin-right: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tabs_class1 {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      overflow-x: hidden;
    }
  }
  li:hover {
    box-shadow: 10px 10px 8px #e7ebef;
  }
}
</style>
